// Bridge to Google's CMP (Funding Choices, loaded via AdSense), which exposes
// the IAB TCF v2.2 API as window.__tcfapi. TCF Purpose 1 (store/access
// information on a device) is what Google maps to analytics_storage, so we use
// it to decide whether PostHog may run. No CMP (e.g. blocked) means no consent.

type TcData = {
  eventStatus?: string;
  gdprApplies?: boolean;
  purpose?: { consents?: Record<number, boolean> };
};

declare global {
  interface Window {
    __tcfapi?: (
      command: string,
      version: number,
      callback: (tcData: TcData, success: boolean) => void
    ) => void;
    googlefc?: {
      callbackQueue?: Array<() => void>;
      showRevocationMessage: () => void;
    };
  }
}

const POLL_MS = 250;
const GIVE_UP_MS = 10_000;

export function onAnalyticsConsent(
  callback: (granted: boolean) => void
): void {
  const start = Date.now();
  const attach = () => {
    if (!window.__tcfapi) {
      if (Date.now() - start < GIVE_UP_MS) setTimeout(attach, POLL_MS);
      return;
    }
    window.__tcfapi('addEventListener', 2, (tcData, success) => {
      if (
        success &&
        (tcData.eventStatus === 'tcloaded' ||
          tcData.eventStatus === 'useractioncomplete')
      ) {
        callback(
          tcData.gdprApplies === false ||
            tcData.purpose?.consents?.[1] === true
        );
      }
    });
  };
  attach();
}

// Re-opens Google's CMP so visitors can change or withdraw consent.
export function showConsentSettings(): void {
  window.googlefc = window.googlefc || ({} as Window['googlefc'] & object);
  window.googlefc.callbackQueue = window.googlefc.callbackQueue || [];
  window.googlefc.callbackQueue.push(() =>
    window.googlefc!.showRevocationMessage()
  );
}
